<template>
  <div class="main-page">
    <center-spinner
      :loading="loading"
    />
    <div class="auth-content">
      <div class="success-section text-center">
        <span>
          <v-icon
            color="#2E7D32"
            size="80"
          >
            mdi-check-circle-outline</v-icon>
        </span>
        <h1 class="header-style">
          Success
        </h1>
        <h2 class="header2-style">
          Registration Completed Successfully
        </h2>
        <v-btn
          class="mt-5 btn-style"
          color="#37474F"
          style="width: 200px; height: 50px;"
          elevation="0"
          @click="toLoginPage()"
        >
          Sign In
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import spinner from '../../components/SpinnerCentre.vue';
    export default {
        name: 'RegistrationSuccessPage',
        components: {
            'center-spinner': spinner,
        },
        data: () => ({
            loading: false,
        }),
        methods: {
            toLoginPage () {
                this.loading = true;
                setTimeout(() => {
                    this.$router.push({ name: 'Login' });
                }, 1000);
            },
        },
    };
</script>

<style scoped>
.main-page{
    position: relative;
}
.auth-content{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
